//配置微信  微服务
import config from '../config'
// import store from '../store'
import {randomString} from './tool'
export const share = (_this) => {

    function ilogHandle() {
        let url = encodeURIComponent(window.location.href)
        let ilogUrl = '//static.zhongan.com/asm.gif?v=' + randomString(18) + '&asm=14.1504.sK6&asm_href=' + url + '&asm_txt='
        _this.ilogSrc = ilogUrl
    }

    var urlParam = _this.$route.query
    let inviter = urlParam.inviter || ''
    if(urlParam.forenv=='wechat'){
        //是否登录？ 获取diandianOA参数
        let diandianOaParam = JSON.parse(localStorage.getItem('_diandian_OA'))
        // console.log(diandianOaParam,'diandianOaParam');
        if (diandianOaParam && diandianOaParam.user && diandianOaParam.user.accessKey) {
            // var userinfo = JSON.parse(diandianOaParam)
            inviter = diandianOaParam.user.thirdUserNo
        } else {
            let oaUrl = ''
            switch (config.ENV) {
                case '-test':
                    oaUrl = 'https://one-test.zhongan.com/fcp/diandian-oa/#/verify?from=mgmshare'
                    break
                case '-uat':
                    oaUrl = 'https://one-uat.zhongan.com/fcp/diandian-oa/#/verify?from=mgmshare'
                    break
                case '':
                    oaUrl = 'https://fin-app.zhongan.com/sh/diandian-oa/#/verify?from=mgmshare'
                    break
            }
            window.location.href = oaUrl
        }
    }


    //获取url参数
    //分享URL campaignNo='HD20171108MGM'
    var shareUrl = '';
    var oneNum = 4;
    var wfUrl = ''
    switch (config.ENV) {
        case '-test':
            oneNum = 4;
            shareUrl = 'https://one-test.zhongan.com/fcp/diandian/#/mgmindex?inviter=' + inviter + '&inviteway=wechat'
            // wfUrl='http://10.253.10.203:30750/auth/4'
            wfUrl = 'https://one-test.zhongan.com/wechat/auth/' + oneNum + ''
            break
        case '-uat':
            oneNum = 5;
            shareUrl = 'https://one-uat.zhongan.com/fcp/diandian/#/mgmindex?inviter=' + inviter + '&inviteway=wechat'
            wfUrl = 'https://one' + config.ENV + '.zhongan.com/wechat/auth/' + oneNum + ''
            break
        case '':
            oneNum = 4;
            shareUrl = 'https://fin-app.zhongan.com/sh/diandian/index.html#/mgmindex?inviter=' + inviter + '&inviteway=wechat'
            wfUrl = 'https://one' + config.ENV + '.zhongan.com/wechat/auth/' + oneNum + ''
            break
    }

    //获取分享信息
    var shareTitle = '秒拿5万，点一点就有钱';
    var shareText = '真金白银等你来，5万借款额度秒变高富帅！小伙伴们快来手慢无！'

    var targetUrl = window.location.href;
    var oAjax = new XMLHttpRequest();
    oAjax.open('POST', wfUrl, true);
    oAjax.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8')
    oAjax.send('url=' + encodeURIComponent(targetUrl));
    oAjax.onreadystatechange = function() {
        if (oAjax.readyState == 4) {
            if (oAjax.status == 200) {
                //成功
                var wixinData = JSON.parse(oAjax.responseText).data;
                //var wixinData=JSON.parse(sessionStorage.getItem('wf'));
                //sessionStorage.setItem('wf',JSON.stringify(wixinData));
                console.log(wixinData, 'wixinData')

                wx.config({
                    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                    appId: wixinData.appid, // 必填，公众号的唯一标识
                    timestamp: wixinData.timestamp, // 必填，生成签名的时间戳
                    nonceStr: wixinData.nonceStr, // 必填，生成签名的随机串
                    signature: wixinData.signature, // 必填，签名，见附录1
                    jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2 onMenuShareAppMessage
                });

                wx.ready(function() {

                    wx.checkJsApi({
                        jsApiList: [
                            'onMenuShareTimeline', 'onMenuShareAppMessage'
                        ], // 需要检测的JS接口列表，所有JS接口列表见附录2,
                        success: function(res) {
                            //console.log(res,'checkJsApi');
                            // 以键值对的形式返回，可用的api值true，不可用为false
                            // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
                        }
                    });

                    //显示按钮
                    wx.showOptionMenu();

                    //朋友圈
                    wx.onMenuShareTimeline({
                        title: shareTitle, // 分享标题
                        link: shareUrl, // 分享链接
                        imgUrl: 'https://fin-app.zhongan.com/sh/event/diandian-mark/dian-icon.png', // 分享图标
                        success: function() {
                            // 用户确认分享后执行的回调函数
                            ilogHandle()
                        },
                        cancel: function() {
                            // 用户取消分享后执行的回调函数
                            //alert(2);
                        }
                    });

                    //朋友
                    wx.onMenuShareAppMessage({
                        title: shareTitle, // 分享标题
                        desc: shareText, // 分享描述
                        link: shareUrl, // 分享链接
                        imgUrl: 'https://fin-app.zhongan.com/sh/event/diandian-mark/dian-icon.png', // 分享图标
                        type: '', // 分享类型,music、video或link，不填默认为link
                        dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
                        success: function() {
                            // 用户确认分享后执行的回调函数
                            ilogHandle()
                        },
                        cancel: function() {
                            // 用户取消分享后执行的回调函数
                        }
                    });

                    //QQ
                    wx.onMenuShareQQ({
                        title: shareTitle, // 分享标题
                        desc: shareText, // 分享描述
                        link: shareUrl, // 分享链接
                        imgUrl: 'https://fin-app.zhongan.com/sh/event/diandian-mark/dian-icon.png', // 分享图标
                        success: function() {
                            // 用户确认分享后执行的回调函数
                            ilogHandle()
                        },
                        cancel: function() {
                            // 用户取消分享后执行的回调函数
                        }
                    });

                    //QQ空间
                    wx.onMenuShareQZone({
                        title: shareTitle, // 分享标题
                        desc: shareText, // 分享描述
                        link: shareUrl, // 分享链接
                        imgUrl: 'https://fin-app.zhongan.com/sh/event/diandian-mark/dian-icon.png', // 分享图标
                        success: function() {
                            // 用户确认分享后执行的回调函数
                            ilogHandle()
                        },
                        cancel: function() {
                            // 用户取消分享后执行的回调函数
                        }
                    });

                });

            } else {
                //失败
                console.log(oAjax.status)
            }
        }
    }.bind(this);
}



// WEBPACK FOOTER //
// ./src/utils/wxshare.js